import React from "react";
import IVRFlow from "./IVRFlow/IVRFlow";
import Routing from "./Routing/Routing";
import CallForwarding from "./CallForwarding/CallForwarding";
import CallConferencing from "./CallConferencing/CallConferencing";
import ExtensionsDetails from "./ExtensionsDetails/ExtensionsDetails";
import ListManager from "./ListManager/ListManager";
import SoundSettings from "./SoundSettings/SoundSettings";
// import SMS from "./SMS/SMS";
import Department from "./Department/Department";
import Events from "./Events/Events";
import Hour from "./Hour/Hour";
import SoundSettingForm from "./SoundSettings/SoundSettingForm";
import NewExtensionsDetails from "./ExtensionsDetails/NewExtensionsDetails";
import EditHour from "./Hour/EditHour";
import { useAuth } from "../../Context/AuthProvider";
import UIkit from "uikit";
import { useEffect } from "react";
import CreateIVR from "./IVRFlow/CreateIVR";
import AddCompany from "../../components/SuperAdmin/Companies/AddCompany";
import Companies from "../../components/SuperAdmin/Companies/Companies";
import Packages from "../../components/SuperAdmin/Packages/Packages";
import MasterNumberDIOD from "../../components/SuperAdmin/MasterNumberDIOD/MasterNumberDIOD";
import ListGroup from "./Group/ListGroup";
import UpdatedSoundSetting from "./SoundSettings/UpdatedSoundSetting";
import CustomizedIvr from "./CustomizedIvr/CustomizedIvr";
import Queue from "./Queue/Queue";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";
import Prompts from "./SoundSettings/Prompts";
// import Events from "./Events/Events";
// import Hour from "./Hour/Hour";

const VPBXManagerMain = () => {
  const { auth } = useAuth();
  useEffect(() => {
    if (auth.role === "3") {
      if (!checkPermissions("vpbx-manager")) {
        window.location.href = "/";
      }
    }

    var trVal = sessionStorage.getItem("ct_licked");
    UIkit.switcher("#renderSwitcher").show(trVal);
  }, []);
  return (
    <>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  <h3>VPBX MANAGER</h3>
                  {auth.role === "2" && (
                    <p>
                      Use this page to create new call routing, forward calls,
                      set up conference calls, manage existing extensions, and
                      much more.
                    </p>
                  )}
                  {auth.role === "1" && (
                    <p>
                      Use this page to create company, add packages or add
                      master number.
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="uk-width-1-3">
                <div className="dashboardIntro uk-text-right">
                  <button>EXPORT DATA</button>
                </div>
              </div> */}

              <div className="uk-width-1-1 ">
                <ul
                  className="uk-subnav callSwitcher"
                  // className="uk-subnav uk-subnav-pill"
                  id="renderSwitcher"
                  uk-switcher="connect: .callClass"
                >
                  {(auth.role === "2" || auth.role === "3") && (
                    <>
                      {auth.role === "2" || checkPermissions("ivr-flow") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 0)}
                        >
                          <a href="#">IVR flow</a>
                        </li>
                      ) : null}

                      {/* {auth.role === "2" || checkPermissions("group") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 1)}
                        >
                          <a href="#">Group</a>
                        </li>
                      ) : null}
                      {auth.role === "2" || checkPermissions("department") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 2)}
                        >
                          <a href="#">Department</a>
                        </li>
                      ) : null} */}
                      {auth.role === "2" || checkPermissions("extensions") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 3)}
                        >
                          <a href="#">Extensions</a>
                        </li>
                      ) : null}
                      {/* {auth.role === "2" || checkPermissions("routing") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 4)}
                        >
                          <a href="#">Routing</a>
                        </li>
                      ) : null} */}
                      {auth.role === "2" || checkPermissions("Forwarding") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 5)}
                        >
                          <a href="#">Forwarding</a>
                        </li>
                      ) : null}
                      {auth.role === "2" || checkPermissions("conferencing") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 6)}
                        >
                          <a href="#">Conferencing</a>
                        </li>
                      ) : null}
                      {auth.role === "2" || checkPermissions("list-manager") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 7)}
                        >
                          <a href="#">List manager</a>
                        </li>
                      ) : null}
                      {auth.role === "2" ||
                      checkPermissions("sound-settings") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 8)}
                        >
                          <a href="#">Sound settings</a>
                        </li>
                      ) : null}
                      {auth.role === "2" || checkPermissions("hours") ? (
                        <li
                          onClick={() => sessionStorage.setItem("ct_licked", 9)}
                        >
                          <a href="#">Hours</a>
                        </li>
                      ) : null}
                      {auth.role === "2" ||
                      checkPermissions("customized-ivr") ? (
                        <li
                          onClick={() =>
                            sessionStorage.setItem("ct_licked", 10)
                          }
                        >
                          <a href="#">Customized IVR</a>
                        </li>
                      ) : null}
                      {auth.role === "2" || checkPermissions("queue") ? (
                        <li
                          onClick={() =>
                            sessionStorage.setItem("ct_licked", 11)
                          }
                        >
                          <a href="#">Queue</a>
                        </li>
                      ) : null}
                      {auth.role === "2" ? (
                        <li
                          onClick={() =>
                            sessionStorage.setItem("ct_licked", 12)
                          }
                        >
                          <a href="#">prompt</a>
                        </li>
                      ) : null}
                      {/* <li onClick={() => sessionStorage.setItem("ct_licked", 7)}>
                        <a href="#">SMS</a>
                      </li> */}
                      {/* <li onClick={() => sessionStorage.setItem("ct_licked", 10)}>
                        <a href="#">Events</a>
                      </li> */}
                    </>
                  )}
                  {auth.role === "1" && (
                    <>
                      <li
                        onClick={() => sessionStorage.setItem("ct_licked", 0)}
                      >
                        <a href="#">Companies</a>
                      </li>
                      <li
                        onClick={() => sessionStorage.setItem("ct_licked", 1)}
                      >
                        <a href="#">Packages</a>
                      </li>
                      <li
                        onClick={() => sessionStorage.setItem("ct_licked", 2)}
                      >
                        <a href="#">Master number DIOD</a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>
            <ul className="uk-switcher uk-margin callClass">
              {(auth.role === "2" || auth.role === "3") && (
                <>
                  {auth.role === "2" || checkPermissions("ivr-flow") ? (
                    <li>
                      {/* <IVRFlow /> */}
                      <CreateIVR />
                    </li>
                  ) : null}

                  {/* {auth.role === "2" || checkPermissions("group") ? (
                    <li>
                      <ListGroup />
                    </li>
                  ) : null}
                  {auth.role === "2" || checkPermissions("department") ? (
                    <li>
                      <Department />
                    </li>
                  ) : null} */}
                  {auth.role === "2" || checkPermissions("extensions") ? (
                    <li>
                      <ExtensionsDetails />
                    </li>
                  ) : null}

                  {/* {auth.role === "2" || checkPermissions("routing") ? (
                    <li>
                      <Routing />
                    </li>
                  ) : null} */}

                  {auth.role === "2" || checkPermissions("Forwarding") ? (
                    <li>
                      <CallForwarding />
                    </li>
                  ) : null}

                  {auth.role === "2" || checkPermissions("conferencing") ? (
                    <li>
                      <CallConferencing />
                    </li>
                  ) : null}
                  {auth.role === "2" || checkPermissions("list-manager") ? (
                    <li>
                      <ListManager />
                    </li>
                  ) : null}

                  {/* {auth.role === "2" || checkIndividualPermission("sound-settings",'read_and_write' ) ? ( */}
                  {auth.role === "2" || checkPermissions("sound-settings") ? (
                    <li>
                      {/* <SoundSettingForm /> */}
                      <UpdatedSoundSetting />
                    </li>
                  ) : null}

                  {auth.role === "2" || checkPermissions("hours") ? (
                    <li>
                      <Hour />
                    </li>
                  ) : null}

                  {auth.role === "2" || checkPermissions("customized-ivr") ? (
                    <li>
                      <CustomizedIvr />
                    </li>
                  ) : null}

                  {auth.role === "2" || checkPermissions("queue") ? (
                    <li>
                      <Queue />
                    </li>
                  ) : null}
                  {auth.role === "2" ? (
                    <li>
                      <Prompts />
                    </li>
                  ) : null}
                  {/* <li><SMS/></li> */}

                  {/* <li><Events/></li> */}
                </>
              )}
              {auth.role === "1" && (
                <>
                  <li>
                    <Companies />
                  </li>
                  <li>
                    <Packages />
                  </li>
                  <li>
                    <MasterNumberDIOD />
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default VPBXManagerMain;
